import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'minus', 'Minus', [["path",{"d":"M5 12l14 0"}]]);